import React from "react";
import { observer } from "owa-mobx-react";
import { StatusBarTargetContext } from "./StatusBarTargetContext";
import { StatusBarZoomContextProvider } from "./StatusBarZoomContext";
import { StatusBarCustomizationContextProvider } from "./StatusBarCustomizationContext";
import { StatusBarViewShortcutsContextProvider } from "./StatusBarViewShortcutsContext";

type StatusBarContextProviderProps = React.PropsWithChildren<{
    // The DOM element where status-bar items are rendered through portals.
    target: HTMLDivElement | null;
}>;

// Shares status-bar data and preferences with module items rendered through portals.
export const StatusBarContextProvider: React.FunctionComponent<StatusBarContextProviderProps> = observer(function StatusBarContextProvider({ children, target }) {
    return (<StatusBarTargetContext.Provider value={target}>
                <StatusBarCustomizationContextProvider>
                    <StatusBarZoomContextProvider>
                        <StatusBarViewShortcutsContextProvider>
                            {children}
                        </StatusBarViewShortcutsContextProvider>
                    </StatusBarZoomContextProvider>
                </StatusBarCustomizationContextProvider>
            </StatusBarTargetContext.Provider>);
}, "StatusBarContextProvider");
